const SCORM_LOCAL_STORAGE_KEY = 'ispring::';

export default function clearScormLocalStorage() {
	Object.keys(localStorage).forEach((key) => {
		if (key.startsWith(SCORM_LOCAL_STORAGE_KEY)) {
			localStorage.removeItem(key);
		}
	});
}
